import { useSelector } from "react-redux";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";
import useSummary from "../../../hooks/useSummary";
import { ADD_MORE_COVERS_POLICY_COVERAGE_ENHANCEMENT } from "../../../pages/motorInsurancePages/addMOreCoversFlow/enhanceYourCoveragePage/enhanceYourCoveragePage";
import {
  ADD_COVERS_ENHANCEMENT_TRAVEL,
  TRAVEL_CHANGE_PLAN_SELECT_PLAN,
} from "../../../pages/motorInsurancePages/newMotorPolicy/Layouts/BottomStickyBtnLayout";
import {
  TRAVEL_RENEWAL_SELECTED_COVERS,
} from "../../../hooks/useTravelRenewalFlow";
import {
  getAdjustSumInsuredResponse,
  getQuoteWithRefundResponse,
} from "../../../redux/features/endorsements/cancellationSlice";
import { getStartPolicyTransferResponse } from "../../../redux/features/endorsements/transferPolicySlice";
import { selectHomeFormData } from "../../../redux/features/homeFormSlice";
import { getQuoteResponse } from "../../../redux/features/motor/getQuoteSlice";
import { getPolicyPremiumResponse } from "../../../redux/features/motor/renewalPremiumSlice";
import { selectNewMotorForm } from "../../../redux/features/newMotorFormSlice";
import { getPolicyViewResponse } from "../../../redux/features/policyDetailsSlice";
import { currencyFormatter, formatPremiumValue } from "../../../utils";
import { PROMO_CODE } from "./viewSummaryPopup";

const Summary = ({
  premiumText,
  // quotationNumber = quoteResponse.PolicyNumber
  passedFrom,
  price,
  vat,
}) => {
  const {
    discount_amount,
    coverage_enhance_data,
    promocode,
    discount_percent,
    total_amount,
    discount,
    discount_percentage,
    vat_additional_amount,
  } = useSummary();

  // Getting the variable from API responses saved in redux for each case. Motor new, Motor renewal, Motor change active plan, etc...
  const quoteResponse = useSelector(getQuoteResponse);
  const policyPremiumResponse = useSelector(getPolicyPremiumResponse);
  const quoteWithRefundResponse = useSelector(getQuoteWithRefundResponse);
  const transferFeesResponse = useSelector(getStartPolicyTransferResponse);
  const policyViewResponse = useSelector(getPolicyViewResponse);
  const adjustSumInsuredResponse = useSelector(getAdjustSumInsuredResponse);

  // Promo code
  const promoCodeDetails = useSelector(selectNewMotorForm)?.[PROMO_CODE];
  const addCoverageEnhancement =
    useSelector(selectNewMotorForm)?.[
      ADD_MORE_COVERS_POLICY_COVERAGE_ENHANCEMENT
    ];

  const travelAddCoverageEnhancement =
    useSelector(selectNewMotorForm)?.[ADD_COVERS_ENHANCEMENT_TRAVEL];

  const travelChangePlanSelection =
    useSelector(selectNewMotorForm)?.[TRAVEL_CHANGE_PLAN_SELECT_PLAN];

  const travelRenewalSelectedCovers =
    useSelector(selectNewMotorForm)?.[TRAVEL_RENEWAL_SELECTED_COVERS];

  // Home insurance data
  const homeFormData = useSelector(selectHomeFormData);

  let quotationNumber = "";
  let premium = "";
  let tax = "";
  let totalPremium = "";

  if (passedFrom == "MotorNew") {
    quotationNumber =
      quoteResponse != ""
        ? quoteResponse.PolicyNumber
        : policyPremiumResponse.PolicyNumber;
    premium =
      quoteResponse != ""
        ? quoteResponse.Premium
        : policyPremiumResponse.Premium;
    tax = quoteResponse != "" ? quoteResponse.Tax : policyPremiumResponse.Tax;
    totalPremium =
      quoteResponse != ""
        ? quoteResponse.TotalPremium
        : policyPremiumResponse.TotalPremium;

    // Add prices from coverage_enhance_data?.coverOptionsState if not empty
    if (coverage_enhance_data?.coverOptionsState?.length > 0) {
      const additionalPremium = coverage_enhance_data.coverOptionsState
        .filter(
          (option) =>
            option.included &&
            Number(option.price) > 0 &&
            !option.defaultIncludedInPlan &&
            !option.includedWithOther,
        ) // Ensure price is a number
        .reduce((sum, option) => sum + Number(option.price), 0); // Convert price to number before summing

      totalPremium += additionalPremium + additionalPremium * 0.1;
      tax = (premium + additionalPremium) * 0.1;
    }
  } else if (passedFrom == "MotorNewReviewAndConfirm") {
    quotationNumber =
      quoteResponse != ""
        ? quoteResponse.PolicyNumber
        : policyPremiumResponse.PolicyNumber;
    premium =
      quoteResponse != ""
        ? quoteResponse.Premium
        : policyPremiumResponse.Premium;
    tax = quoteResponse != "" ? quoteResponse.Tax : policyPremiumResponse.Tax;
    totalPremium =
      quoteResponse != ""
        ? quoteResponse.TotalPremium
        : policyPremiumResponse.TotalPremium;
  } else if (passedFrom == "MotorRenewal") {
    quotationNumber =
      policyPremiumResponse != "" ? policyPremiumResponse.PolicyNumber : "--";
    premium = policyPremiumResponse != "" ? policyPremiumResponse.Premium : "-";
    tax = policyPremiumResponse != "" ? policyPremiumResponse.Tax : "-";
    totalPremium =
      policyPremiumResponse != "" ? policyPremiumResponse.TotalPremium : "-";

    // Add prices from coverage_enhance_data?.coverOptionsState if not empty
    if (coverage_enhance_data?.coverOptionsState?.length > 0) {
      const additionalPremium = coverage_enhance_data.coverOptionsState
        .filter(
          (option) =>
            option.included &&
            Number(option.price) > 0 &&
            !option.defaultIncludedInPlan &&
            !option.includedWithOther,
        ) // Ensure price is a number
        .reduce((sum, option) => sum + Number(option.price), 0); // Convert price to number before summing

      totalPremium += additionalPremium + additionalPremium * 0.1;
      tax = (premium + additionalPremium) * 0.1;
    }
  } else if (passedFrom == "MotorRenewalReviewAndConfirm") {
    quotationNumber =
      policyPremiumResponse != "" ? policyPremiumResponse.PolicyNumber : "--";
    premium = policyPremiumResponse != "" ? policyPremiumResponse.Premium : "-";
    tax = policyPremiumResponse != "" ? policyPremiumResponse.Tax : "-";
    totalPremium =
      policyPremiumResponse != "" ? policyPremiumResponse.TotalPremium : "-";
  } else if (passedFrom == "MotorChangeActivePlan") {
    quotationNumber =
      quoteWithRefundResponse != ""
        ? quoteWithRefundResponse.PolicyNumber
        : "-";
    premium =
      quoteWithRefundResponse != "" ? quoteWithRefundResponse.Premium : "-";
    tax = quoteWithRefundResponse != "" ? quoteWithRefundResponse.Tax : "-";
    totalPremium =
      quoteWithRefundResponse != ""
        ? quoteWithRefundResponse.TotalPremium
        : "-";
  } else if (passedFrom == "transferPolicy") {
    quotationNumber = policyViewResponse
      ? policyViewResponse.PolicyHeader?.QuoteNumber
      : "Q";
    const vatRate = 0.1;
    // Handle missing transfer fees data gracefully
    const fees = transferFeesResponse?.Fees || 0;
    const premiumToPay = transferFeesResponse?.PremiumToPay || 0;
    premium = fees + premiumToPay;
    tax = parseFloat(
      (
        (fees + premiumToPay) *
        0.1
      ).toFixed(2),
    );

    totalPremium =
      (fees + premiumToPay) *
      (1 + vatRate);
  } else if (passedFrom == "MotorAdjustSumInsured") {
    quotationNumber = policyViewResponse
      ? policyViewResponse.PolicyHeader?.QuoteNumber
      : "Q";

    premium = adjustSumInsuredResponse.EndorsementFees;
    tax = adjustSumInsuredResponse.EndorsementFeesVAT;
    totalPremium = adjustSumInsuredResponse.EndorsementFeesTotal;
  } else if (passedFrom == "AddCovers") {
    // Initialize values for AddCovers
    quotationNumber =
      policyViewResponse?.PolicyHeader?.QuoteNumber ?? "Q-ADD-COVERS";
    totalPremium = 0;
    premium = 0;
    tax = 0;

    if (addCoverageEnhancement?.coverOptionsState?.length > 0) {
      const additionalPremium = addCoverageEnhancement.coverOptionsState
        .filter(
          (option) =>
            option.included &&
            Number(option.price) > 0 &&
            !option.defaultIncludedInPlan &&
            !option.includedWithOther,
        ) // Only covers that are selected and not default included
        .reduce((sum, option) => sum + Number(option.price), 0); // Sum the prices

      console.log(
        "Summary AddCovers - Additional Premium from selected covers:",
        additionalPremium,
      );
      console.log(
        "Summary AddCovers - Selected covers:",
        addCoverageEnhancement.coverOptionsState.filter((opt) => opt.included),
      );

      premium = additionalPremium;
      tax = additionalPremium * 0.1; // 10% VAT on additional premium
      totalPremium = additionalPremium + tax; // Premium + VAT

      console.log("Summary AddCovers - Final calculations:", {
        additionalPremium,
        tax,
        totalPremium,
      });
    }
  } else if (passedFrom == "TravelAddCovers") {
    // Initialize values for Travel Add Covers
    quotationNumber =
      policyViewResponse?.PolicyHeader?.QuoteNumber ?? "T-ADD-COVERS";
    totalPremium = 0;
    premium = 0;
    tax = 0;

    if (travelAddCoverageEnhancement?.coverOptionsState?.length > 0) {
      const additionalPremium = travelAddCoverageEnhancement.coverOptionsState
        .filter(
          (option) =>
            option.included &&
            Number(option.price) > 0 &&
            !option.defaultIncludedInPlan,
        ) // Only covers that are selected and not default included
        .reduce((sum, option) => sum + Number(option.price), 0); // Sum the prices

      console.log(
        "Summary TravelAddCovers - Additional Premium from selected covers:",
        additionalPremium,
      );
      console.log(
        "Summary TravelAddCovers - Selected covers:",
        travelAddCoverageEnhancement.coverOptionsState.filter(
          (opt) => opt.included,
        ),
      );

      premium = additionalPremium;
      tax = additionalPremium * 0.1; // 10% VAT on additional premium
      totalPremium = additionalPremium + tax; // Premium + VAT

      console.log("Summary TravelAddCovers - Final calculations:", {
        additionalPremium,
        tax,
        totalPremium,
      });
    }
  } else if (passedFrom == "TravelChangePlan") {
    // Initialize values for Travel Change Plan
    quotationNumber =
      policyViewResponse?.PolicyHeader?.QuoteNumber ?? "T-CHANGE-PLAN";
    totalPremium = 0;
    premium = 0;
    tax = 0;

    if (travelChangePlanSelection) {
      console.log(
        "Summary TravelChangePlan - Selected plan:",
        travelChangePlanSelection,
      );

      // Use the selected plan's pricing
      premium =
        travelChangePlanSelection.premium ||
        travelChangePlanSelection.totalPremium ||
        0;
      tax = travelChangePlanSelection.tax || premium * 0.1; // 10% VAT if not provided
      totalPremium = travelChangePlanSelection.totalPremium || premium + tax; // Total premium

      console.log("Summary TravelChangePlan - Final calculations:", {
        premium,
        tax,
        totalPremium,
      });
    }
  } else if (passedFrom == "TravelRenewal") {
    // Initialize values for Travel Renewal - use policyViewResponse data
    quotationNumber =
      policyViewResponse?.PolicyHeader?.QuoteNumber ??
      policyViewResponse?.PolicyHeader?.PolicyNumber ??
      "T-RENEWAL";

    // Get base premium data from PolicyViewResponse
    const basePremium = parseFloat(policyViewResponse?.PolicyHeader?.Premium) || 0;
    const baseTax = parseFloat(policyViewResponse?.PolicyHeader?.Tax) || 0;

    // Calculate additional covers premium
    let additionalCoversPremium = 0;
    if (travelRenewalSelectedCovers?.coverOptionsState?.length > 0) {
      additionalCoversPremium = travelRenewalSelectedCovers.coverOptionsState
        .filter(
          (option) =>
            option.included &&
            Number(option.price) > 0 &&
            !option.defaultIncludedInPlan,
        )
        .reduce((sum, option) => sum + Number(option.price), 0);
    }
    const additionalCoversTax = additionalCoversPremium * 0.1;

    premium = basePremium + additionalCoversPremium;
    tax = baseTax + additionalCoversTax;
    totalPremium = premium + tax;

    console.log("Summary TravelRenewal - Policy data:", {
      quotationNumber,
      basePremium,
      baseTax,
      additionalCoversPremium,
      additionalCoversTax,
      premium,
      tax,
      totalPremium,
    });
  } else if (passedFrom == "personalAccidentRenewal") {
    // Personal Accident Renewal - use policyPremiumResponse (calculated premium API)
    // for accurate Tax/Premium/Total. policyViewResponse.PolicyHeader.Tax reflects
    // the original policy and may be stale.
    quotationNumber =
      policyPremiumResponse?.PolicyNumber ??
      policyViewResponse?.PolicyHeader?.QuoteNumber ??
      policyViewResponse?.PolicyHeader?.PolicyNumber ??
      "PA-RENEWAL";

    premium = parseFloat(policyPremiumResponse?.Premium) || 0;
    tax = parseFloat(policyPremiumResponse?.Tax) || 0;
    totalPremium = parseFloat(policyPremiumResponse?.TotalPremium) || (premium + tax);

    console.log("Summary personalAccidentRenewal - Policy data:", {
      quotationNumber,
      premium,
      tax,
      totalPremium,
    });
  } else if (passedFrom == "HomeInsurance") {
    // TODO: Home insurance should use the API (getHomeQuote) instead of frontend calculations
    // The calculateHomePremium function and homePremium.js file have been removed
    // This fallback calculation should be replaced with API response data
    quotationNumber =
      "H" + Math.random().toString(36).substr(2, 6).toUpperCase();
    premium = 0; // Should come from API
    tax = 0; // Should come from API
    totalPremium = 0; // Should come from API
  } else if (passedFrom == "homeRenewal") {
    // Home Renewal - use policyPremiumResponse (calculated premium API) for pricing.
    // policyViewResponse.PolicyHeader.Tax is the old policy tax and is often 0;
    // the correct VAT 10% figures come from the /policy/premium API response.
    quotationNumber =
      policyPremiumResponse?.PolicyNumber ??
      policyViewResponse?.PolicyHeader?.QuoteNumber ??
      policyViewResponse?.PolicyHeader?.PolicyNumber ??
      "H-RENEWAL";

    premium = parseFloat(policyPremiumResponse?.Premium) || 0;
    tax = parseFloat(policyPremiumResponse?.Tax) || 0;
    totalPremium = parseFloat(policyPremiumResponse?.TotalPremium) || (premium + tax);

    console.log("Summary homeRenewal - Policy data:", {
      quotationNumber,
      premium,
      tax,
      totalPremium,
    });
  } else if (passedFrom == "personalCyberRenewal") {
    // Personal Cyber Renewal - use policyPremiumResponse (calculated premium API)
    // for accurate Tax/Premium/Total. policyViewResponse.PolicyHeader.Tax reflects
    // the original policy and may be stale when the user picks a different plan.
    quotationNumber =
      policyPremiumResponse?.PolicyNumber ??
      policyViewResponse?.PolicyHeader?.QuoteNumber ??
      policyViewResponse?.PolicyHeader?.PolicyNumber ??
      "PC-RENEWAL";

    premium = parseFloat(policyPremiumResponse?.Premium) || 0;
    tax = parseFloat(policyPremiumResponse?.Tax) || 0;
    totalPremium = parseFloat(policyPremiumResponse?.TotalPremium) || (premium + tax);

    console.log("Summary personalCyberRenewal - Policy data:", {
      quotationNumber,
      premium,
      tax,
      totalPremium,
    });
  } else {
    quotationNumber =
      quoteResponse != ""
        ? quoteResponse.PolicyNumber
        : policyPremiumResponse.PolicyNumber;
    premium =
      quoteResponse != ""
        ? quoteResponse.Premium
        : policyPremiumResponse.Premium;
    tax = quoteResponse != "" ? quoteResponse.Tax : policyPremiumResponse.Tax;
    totalPremium =
      quoteResponse != ""
        ? quoteResponse.TotalPremium
        : policyPremiumResponse.TotalPremium;
  }

  // const quotationNumber = quoteResponse != "" ? quoteResponse.PolicyNumber : policyPremiumResponse.PolicyNumber;
  // const premium = quoteResponse != "" ? quoteResponse.Premium : policyPremiumResponse.Premium;
  // const tax = quoteResponse != "" ? quoteResponse.Tax : policyPremiumResponse.Tax;
  // const totalPremium = quoteResponse != "" ? quoteResponse.TotalPremium : policyPremiumResponse.TotalPremium;

  // let total = parseInt(vat_additional_amount||0) + total_amount - (discount_amount || 0);
  const translate = useLanguageTranslate();
  const premiumTitle = premiumText
    ? translate(premiumText.en, premiumText.ar)
    : translate("Premium", "المبلغ");
  console.log(premiumTitle, premiumText);

  // Flows that display premium values with 3 decimals (same formatting as the
  // Review & Confirm screen / SummaryContent), instead of the 2-decimal currencyFormatter.
  const useThreeDecimalFormat = [
    "TravelRenewal",
    "TravelChangePlan",
    "homeRenewal",
    "personalAccidentRenewal",
    "personalCyberRenewal",
  ].includes(passedFrom);
  const formatAmount = (amount) =>
    useThreeDecimalFormat
      ? formatPremiumValue(amount, "en-US", 3)
      : currencyFormatter(amount);

  return (
    <div className="rounded-lg summary-content">
      {/* Quotation Number */}
      <div className="flex items-center justify-between bg-[#E8F4D8] px-4 py-2.5 rounded-md mb-2">
        <span className="text-[#5B6871] text-xs not-italic font-medium leading-6">
          {translate("Quotation Number", "رقم التسعيرة")}
        </span>
        <span className="text-[#5B6871] text-xs not-italic font-medium leading-6">
          {quotationNumber}
        </span>
      </div>
      {/* For TravelAddCovers: show individual cover lines instead of a single Premium line */}
      {passedFrom === "TravelAddCovers" &&
        travelAddCoverageEnhancement?.coverOptionsState
          ?.filter(
            (option) =>
              option.included &&
              Number(option.price) > 0 &&
              !option.defaultIncludedInPlan,
          )
          ?.map((value) => (
            <div
              className="flex justify-between mb-2 px-0 py-2.5"
              key={value.coverCode || value.code}
            >
              <span className="text-[#1A2024] text-sm not-italic font-normal rtl:font-medium leading-6">
                {translate(value.name, value.name_ar || value.name)}
              </span>
              <span className="text-[#1A2024] text-sm not-italic font-normal rtl:font-medium leading-6 rtl:flex rtl:flex-row-reverse rtl:gap-1">
                <span>{translate("BHD", "د.ب")}</span> <span>{currencyFormatter(value.price)}</span>
              </span>
            </div>
          ))}
      {/* Premium line for all flows (except TravelAddCovers) - MUST come before add-ons for TravelRenewal */}
      {passedFrom !== "TravelAddCovers" && (
        <div className="flex justify-between mb-2 px-0 py-2.5">
          <span className="text-[#1A2024] text-sm not-italic font-normal rtl:font-medium leading-6">
            {premiumTitle}
          </span>
          {premium > 0 && (
            <span className="text-[#1A2024] text-sm not-italic font-normal rtl:font-medium leading-6 rtl:flex rtl:flex-row-reverse rtl:gap-1">
              <span>{translate("BHD", "د.ب")}</span> <span>{formatAmount(premium)}</span>
            </span>
          )}
        </div>
      )}
      {/* For TravelRenewal: show selected additional covers AFTER premium */}
      {passedFrom === "TravelRenewal" &&
        travelRenewalSelectedCovers?.coverOptionsState
          ?.filter(
            (option) =>
              option.included &&
              Number(option.price) > 0 &&
              !option.defaultIncludedInPlan,
          )
          ?.sort((a, b) => {
            // Sort order: Winter Activities (CPER17) first, then Summer Activities (CPER137)
            const orderMap = { CPER17: 1, CPER137: 2 };
            const aCode = a.coverCode || a.code;
            const bCode = b.coverCode || b.code;
            return (orderMap[aCode] || 999) - (orderMap[bCode] || 999);
          })
          ?.map((value) => (
            <div
              className="flex justify-between mb-2 px-0 py-2.5"
              key={value.coverCode || value.code}
            >
              <span className="text-[#1A2024] text-sm not-italic font-normal rtl:font-medium leading-6">
                {translate(value.name, value.name_ar || value.name)}
              </span>
              <span className="text-[#1A2024] text-sm not-italic font-normal rtl:font-medium leading-6 rtl:flex rtl:flex-row-reverse rtl:gap-1">
                <span>{translate("BHD", "د.ب")}</span> <span>{formatPremiumValue(value.price, "en-US", 3)}</span>
              </span>
            </div>
          ))}
      {/* Motor Insurance Coverage Enhancement */}
      {coverage_enhance_data?.coverOptionsState
        ?.filter(
          (option) =>
            option.included &&
            option.price > 0 &&
            !option.defaultIncludedInPlan &&
            !option.includedWithOther,
        )
        ?.map((value) => (
          <div
            className="flex justify-between mb-2 px-0 py-2.5"
            key={value.name}
          >
            <span className="text-[#1A2024] text-sm not-italic font-normal leading-6">
              {value.name}
            </span>
            <span className="text-[#1A2024] text-sm not-italic font-normal leading-6 rtl:flex rtl:flex-row-reverse rtl:gap-1">
              <span>{translate("BHD", "د.ب")}</span> <span>{currencyFormatter(value.price)}</span>
            </span>
          </div>
        ))}
      {/* Home Insurance Coverage Breakdown */}
      {passedFrom == "HomeInsurance" && homeFormData && (
        <>
          {homeFormData.covers?.allRisk && (
            <div className="flex justify-between mb-2 px-0 py-2.5 border-t-[#DDE2E4] border-t border-solid">
              <span className="text-[#1A2024] text-sm not-italic font-normal leading-6">
                {translate("All Risk", "جميع المخاطر")}
              </span>
              <span className="text-[#1A2024] text-sm not-italic font-normal leading-6 rtl:flex rtl:flex-row-reverse rtl:gap-1">
                <span>{translate("BHD", "د.ب")}</span> <span>{currencyFormatter(10.0)}</span>
              </span>
            </div>
          )}
          {homeFormData.covers?.domesticHelper && (
            <div className="flex justify-between mb-2 px-0 py-2.5 border-t-[#DDE2E4] border-t border-solid">
              <span className="text-[#1A2024] text-sm not-italic font-normal leading-6">
                {translate("Domestic Helper", "العامل المنزلي")}
              </span>
              <span className="text-[#1A2024] text-sm not-italic font-normal leading-6 rtl:flex rtl:flex-row-reverse rtl:gap-1">
                <span>{translate("BHD", "د.ب")}</span> <span>{currencyFormatter(14.0)}</span>
              </span>
            </div>
          )}
          {homeFormData.covers?.vipCover && (
            <div className="flex justify-between mb-2 px-0 py-2.5 border-t-[#DDE2E4] border-t border-solid">
              <span className="text-[#1A2024] text-sm not-italic font-normal leading-6">
                {translate("VIP Cover", "التغطية المميزة")}
              </span>
              <span className="text-[#1A2024] text-sm not-italic font-normal leading-6 rtl:flex rtl:flex-row-reverse rtl:gap-1">
                <span>{translate("BHD", "د.ب")}</span> <span>{currencyFormatter(1.0)}</span>
              </span>
            </div>
          )}
          {homeFormData.covers?.sabotageAndTerrorism && (
            <div className="flex justify-between mb-2 px-0 py-2.5 border-t-[#DDE2E4] border-t border-solid">
              <span className="text-[#1A2024] text-sm not-italic font-normal leading-6">
                {translate("Terrorism Attack", "التخريب والإرهاب")}
              </span>
              <span className="text-[#1A2024] text-sm not-italic font-normal leading-6 rtl:flex rtl:flex-row-reverse rtl:gap-1">
                <span>{translate("BHD", "د.ب")}</span> <span>{currencyFormatter(1.0)}</span>
              </span>
            </div>
          )}
          {(homeFormData.homeDetails?.accidentalDamage ||
            homeFormData.homeDetails?.contentsAccidentalDamage) && (
            <div className="flex justify-between mb-2 px-0 py-2.5 border-t-[#DDE2E4] border-t border-solid">
              <span className="text-[#1A2024] text-sm not-italic font-normal leading-6">
                {translate("Accidental Damage", "الأضرار العرضية")}
              </span>
              <span className="text-[#1A2024] text-sm not-italic font-normal leading-6 rtl:flex rtl:flex-row-reverse rtl:gap-1">
                <span>{translate("BHD", "د.ب")}</span>{" "}
                <span>{currencyFormatter(
                  homeFormData.homeDetails?.accidentalDamage &&
                    homeFormData.homeDetails?.contentsAccidentalDamage
                    ? 2.0
                    : 1.0,
                )}</span>
              </span>
            </div>
          )}
          {(homeFormData.homeDetails?.landslideSubsidence ||
            homeFormData.homeDetails?.contentsLandslideSubsidence) && (
            <div className="flex justify-between mb-2 px-0 py-2.5 border-t-[#DDE2E4] border-t border-solid">
              <span className="text-[#1A2024] text-sm not-italic font-normal leading-6">
                {translate("Landslide / Subsidence", "انزلاق أرضي/انحدار أرضي")}
              </span>
              <span className="text-[#1A2024] text-sm not-italic font-normal leading-6 rtl:flex rtl:flex-row-reverse rtl:gap-1">
                <span>{translate("BHD", "د.ب")}</span>{" "}
                <span>{currencyFormatter(
                  homeFormData.homeDetails?.landslideSubsidence &&
                    homeFormData.homeDetails?.contentsLandslideSubsidence
                    ? 2.0
                    : 1.0,
                )}</span>
              </span>
            </div>
          )}
        </>
      )}
      {/* <div className="flex justify-between mb-2 px-0 py-2.5">
        <span className='text-[#1A2024] text-sm not-italic font-normal leading-6'>Total before VAT & Discount</span>
        <span className='text-[#1A2024] text-sm not-italic font-normal leading-6'>BHD {total?.toFixed(3)}</span>
      </div> */}
      {promoCodeDetails?.promoCodeApplied == true && (
        <div className="flex justify-between mb-2 px-0 py-2.5 border-t-[#DDE2E4] border-t border-solid">
          <span className="text-[#1A2024] text-sm not-italic font-normal leading-6">
            {translate("Discount", "خصم")}
          </span>
          <span className="text-[#F2271C] text-sm not-italic font-normal leading-6 rtl:flex rtl:flex-row-reverse rtl:gap-1">
            <span>- {translate("BHD", "د.ب")}</span> <span>{currencyFormatter(promoCodeDetails.promoCodeDifference)}</span>
          </span>
        </div>
      )}
      {/* VAT */}
      <div className="flex justify-between mb-2 px-0 py-2.5 border-t-[#DDE2E4] border-t border-solid">
        <span className="text-[#1A2024] text-sm not-italic font-normal rtl:font-medium leading-6">
          {translate("VAT", "ضريبة القيمة المضافة")} 10%
        </span>
        {promoCodeDetails?.promoCodeApplied == true ? (
          <span className="text-[#1A2024] text-sm not-italic font-normal rtl:font-medium leading-6 rtl:flex rtl:flex-row-reverse rtl:gap-1">
            <span>{translate("BHD", "د.ب")}</span>{" "}
            <span>{currencyFormatter(promoCodeDetails?.promoCodeTax) || 0}</span>
          </span>
        ) : (
          <span className="text-[#1A2024] text-sm not-italic font-normal rtl:font-medium leading-6 rtl:flex rtl:flex-row-reverse rtl:gap-1">
            <span>{translate("BHD", "د.ب")}</span> <span>{formatAmount(tax) || 0}</span>
          </span>
        )}
      </div>
      {/* Total */}
      <div className="flex justify-between px-0 py-2.5 border-t-[#DDE2E4] border-t border-solid">
        <span className="text-[#1A2024] text-base not-italic font-extrabold rtl:font-extrabold leading-6">
          {translate("Total", "المجموع")}
        </span>
        {totalPremium > 0 &&
          (promoCodeDetails?.promoCodeApplied ? (
            <span className="text-[#1A2024] text-base not-italic font-extrabold rtl:font-extrabold leading-6 rtl:flex rtl:flex-row-reverse rtl:gap-1">
              <span>{translate("BHD", "د.ب")}</span>{" "}
              <span>{currencyFormatter(promoCodeDetails?.promoCodeTotalPremium)}</span>
            </span>
          ) : (
            <span className="text-[#1A2024] text-base not-italic font-extrabold rtl:font-extrabold leading-6 rtl:flex rtl:flex-row-reverse rtl:gap-1">
              <span>{translate("BHD", "د.ب")}</span> <span>{formatAmount(totalPremium)}</span>
            </span>
          ))}
      </div>

      {/* Motor Insurance Add Covers - Add-on Premium Breakdown (displayed below Total) */}
      {passedFrom == "AddCovers" &&
        addCoverageEnhancement?.coverOptionsState?.filter(
          (option) =>
            option.included &&
            Number(option.price) > 0 &&
            !option.defaultIncludedInPlan &&
            !option.includedWithOther,
        )?.length > 0 && (
          <div className="mt-4 pt-4 border-t-[#DDE2E4] border-t border-solid">
            <h4 className="text-[#1A2024] text-sm not-italic font-semibold leading-6 mb-2">
              {translate("Add-on Premium", "قسط الإضافات")}
            </h4>
            {addCoverageEnhancement?.coverOptionsState
              ?.filter(
                (option) =>
                  option.included &&
                  Number(option.price) > 0 &&
                  !option.defaultIncludedInPlan &&
                  !option.includedWithOther,
              )
              ?.map((value) => (
                <div
                  className="flex justify-between mb-2 px-0 py-1"
                  key={value.coverCode || value.code}
                >
                  <span className="text-[#5B6871] text-sm not-italic font-normal leading-6">
                    {translate(value.name, value.name_ar || value.name)}
                  </span>
                  <span className="text-[#1A2024] text-sm not-italic font-normal leading-6 rtl:flex rtl:flex-row-reverse rtl:gap-1">
                    <span>{translate("BHD", "د.ب")}</span> <span>{currencyFormatter(value.price)}</span>
                  </span>
                </div>
              ))}
          </div>
        )}
    </div>
  );
};

export default Summary;
